<template>
    <footer class="custom-footer bg-dark py-5 position-relative">
        <BContainer>
            <BRow>

                <BCol sm="6" class="text-center my-auto">
                    <img src="@/assets/images/libertas-dark.svg" alt="logo light" height="30">
                </BCol>

                <BCol sm="6" class="d-flex justify-content-center">

                    <a href="https://api.whatsapp.com/send/?phone=5511974242752" target="_blank" class="text-white mx-1">
                        <i class="ri-whatsapp-line fs-1"></i>
                    </a>

                    <a href="https://www.instagram.com/libertas.instituto/" target="_blank" class="text-white mx-1">
                        <i class="ri-instagram-line fs-1"></i>
                    </a>

                    <a href="mailto:contato@institutolibertas.org.br" class="text-white mx-1">
                        <i class="ri-mail-line fs-1"></i>
                    </a>

                </BCol>

                <BCol sm="12" class="text-center mt-5">
                    <p class="copy-rights mb-0 currentyear">{{ new Date().getFullYear() }} © LifeCode
                    </p>
                </BCol>
            </BRow>
        </BContainer>
    </footer>

    <BButton variant="danger" @click="topFunction" class="btn-icon landing-back-top" id="back-to-top">
        <i class="ri-arrow-up-line"></i>
    </BButton>
</template>
<script setup>

function topFunction() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
}

</script>
